<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Factureren"
      @next-step="$router.push({ name: 'checkOutInvoice' })"
      @prev-step="$router.push({ name: 'checkOutCart' })"
    ></next-prev-menu>
    <deliver-pickup
      :orderDetails="checkOutStore.orderDetails"
      :shop="checkOutStore.shop"
      :dates="checkOutStore.dates"
      @updateOrder="updateOrder"
    ></deliver-pickup>
  </div>
</template>

<script>
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import OrderMixin from '@/mixins/OrderMixin'
import DeliverPickup from '@/components/DeliverPickup.vue'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'
import { mapStores } from 'pinia'

export default {
  data() {
    return {}
  },
  mixins: [OrderMixin],
  components: {
    NextPrevMenu,
    DeliverPickup
  },
  methods: {
    updateOrder(val) {
      this.checkOutStore.updateOrderDetails(val[0], val[1])
    }
  },
  computed: {
    ...mapStores(useCheckOutStore)
  },
  created() {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.card {
  height: 590px;
}
</style>
